import React from 'react';
import { Result } from "antd";

const NotFoundPage = () => {
    return (
        <Result
            style={{marginTop: 120}}
            status="404"
            title="404"
            subTitle="К сожалению, страница, которую вы посетили, не существует."
        />
    );
};

export default NotFoundPage;